import { useMemo } from "react";
import { useApi, apiResolver } from "@/api/useApi";
import {
  JourniesDataResponse,
  GetJourniesRequest,
  GetQuackchatInitResponse,
  GetQuackchatInitRequest,
} from "./Journey.model";

function buildJourniesQueryParams(params: GetJourniesRequest): URLSearchParams {
  const queryParams = new URLSearchParams();
  if (params.startDate) {
    queryParams.append("startDate", params.startDate);
  }
  if (params.endDate) {
    queryParams.append("endDate", params.endDate);
  }
  if (params.thresholdDefinition) {
    queryParams.append("thresholdDefinition", params.thresholdDefinition);
  }
  if (params.thresholdNavigationNumber !== undefined) {
    queryParams.append(
      "thresholdNavigationNumber",
      params.thresholdNavigationNumber.toString()
    );
  }
  return queryParams;
}

export function useJourneyApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      getJourniesData: async (params: GetJourniesRequest) => {
        const queryParams = buildJourniesQueryParams(params);
        const url = `/sessions-api/journies/stats${
          queryParams.toString() ? `?${queryParams.toString()}` : ""
        }`;
        return apiResolver<JourniesDataResponse>(api.get(url));
      },
      getQuackchatInitData: async (params: GetQuackchatInitRequest) => {
        const queryParams = buildJourniesQueryParams(params);
        if (params.pageId) {
          queryParams.append("pageId", params.pageId);
        }
        const url = `/sessions-api/journies/stats-by-quackchat-init${
          queryParams.toString() ? `?${queryParams.toString()}` : ""
        }`;
        return apiResolver<GetQuackchatInitResponse>(api.get(url));
      },
    }),
    [api]
  );
}
